import { render, staticRenderFns } from "./accounting.vue?vue&type=template&id=d68384d0"
import script from "./accounting.vue?vue&type=script&lang=js"
export * from "./accounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports